import { Chip } from '@mui/material';
import { getSelectorAttribute, integrationsPageSelectors } from '@vy/app-selectors';
import type { FC } from 'react';
import type { BadgeOption } from '../../enums/BadgeOptions';
import { badgeMetadata } from './constants';

type CardBadgeProps = {
  badgeOption: BadgeOption;
};

export const CardBadge: FC<CardBadgeProps> = ({ badgeOption }) => {
  const { label, background, textColor } = badgeMetadata[badgeOption];

  return (
    <Chip
      label={label}
      size="small"
      variant="filled"
      sx={{
        background,
        color: textColor,
      }}
      {...getSelectorAttribute(integrationsPageSelectors.card.badge)}
    />
  );
};
